import type { FormaRentConfig, OpenParams } from '../types';

type IframeConfig = Pick<FormaRentConfig, 'user' | 'owner' | 'theme' | 'lang'>;

/**
 * Строит URL для iframe форма: `{baseUrl}/booking?id=...&product=...&...`
 * либо `{baseUrl}/booking?owner=<ключ>` для витрины партнёра.
 * Значения кодирует через URLSearchParams. theme=auto в query не пишет.
 */
export function buildIframeUrl(
  baseUrl: string,
  config: IframeConfig,
  params?: OpenParams,
): string {
  const normalizedBase = baseUrl.replace(/\/+$/, '');
  const qs = new URLSearchParams();

  // Витрина партнёра адресуется ключом; демо-фолбэк тут неуместен —
  // сломанный ключ должен вести на 404, а не на чужой демо-каталог
  if (config.owner) {
    qs.set('owner', config.owner);
  } else {
    qs.set('id', config.user || "e2a82dfa-b6df-4150-8101-b411d0202657");
  }

  if (params?.product !== undefined && params.product !== '') {
    qs.set('product', String(params.product));
  }
  if (params?.option !== undefined && params.option !== '') {
    qs.set('option', String(params.option));
  }
  if (params?.category !== undefined && params.category !== '') {
    qs.set('category', params.category);
  }

  if (config.theme && config.theme !== 'auto') {
    qs.set('theme', config.theme);
  }
  if (config.lang) {
    qs.set('lang', config.lang);
  }

  return `${normalizedBase}/booking?${qs.toString()}`;
}
